import {
  GET_DRIVER_CERTIFICATIONS,
  GET_DRIVER_CERTIFICATION,
  ADD_DRIVER_CERTIFICATION,
  UPDATE_DRIVER_CERTIFICATION,
  DELETE_DRIVER_CERTIFICATION,
  GET_CONDUCTOR_CERTIFICATIONS,
  GET_CONDUCTOR_CERTIFICATION,
  ADD_CONDUCTOR_CERTIFICATION,
  UPDATE_CONDUCTOR_CERTIFICATION,
  DELETE_CONDUCTOR_CERTIFICATION,
  SET_LOADING,
  SET_ERROR
} from '../../actions/certification'

const initialState = {
  driverCertifications: [],
  conductorCertifications: [],
  selectedDriverCertification: null,
  selectedConductorCertification: null,
  loading: false,
  error: null
}

const certificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    
    case SET_ERROR:
      return {
        ...state,
        error: action.payload
      }

    // Driver Certification Cases
    case GET_DRIVER_CERTIFICATIONS:
      return {
        ...state,
        driverCertifications: action.payload,
        error: null
      }

    case GET_DRIVER_CERTIFICATION:
      return {
        ...state,
        selectedDriverCertification: action.payload,
        error: null
      }

    case ADD_DRIVER_CERTIFICATION:
      return {
        ...state,
        driverCertifications: [action.payload, ...state.driverCertifications],
        error: null
      }

    case UPDATE_DRIVER_CERTIFICATION:
      return {
        ...state,
        driverCertifications: state.driverCertifications.map((cert) => (cert.id === action.payload.id ? action.payload : cert)),
        selectedDriverCertification: action.payload,
        error: null
      }

    case DELETE_DRIVER_CERTIFICATION:
      return {
        ...state,
        driverCertifications: state.driverCertifications.filter(
          (cert) => cert.id !== action.payload
        ),
        error: null
      }

    // Conductor Certification Cases
    case GET_CONDUCTOR_CERTIFICATIONS:
      return {
        ...state,
        conductorCertifications: action.payload,
        error: null
      }

    case GET_CONDUCTOR_CERTIFICATION:
      return {
        ...state,
        selectedConductorCertification: action.payload,
        error: null
      }

    case ADD_CONDUCTOR_CERTIFICATION:
      return {
        ...state,
        conductorCertifications: [action.payload, ...state.conductorCertifications],
        error: null
      }

    case UPDATE_CONDUCTOR_CERTIFICATION:
      return {
        ...state,
        conductorCertifications: state.conductorCertifications.map((cert) => (cert.id === action.payload.id ? action.payload : cert)),
        selectedConductorCertification: action.payload,
        error: null
      }

    case DELETE_CONDUCTOR_CERTIFICATION:
      return {
        ...state,
        conductorCertifications: state.conductorCertifications.filter(
          (cert) => cert.id !== action.payload
        ),
        error: null
      }

    default:
      return state
  }
}

export default certificationReducer
